import React from 'react';
import ReactDom from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import RootContainer from './app/routes/Root';

import { setTranslations, setDefaultLanguage, setLanguageCookie, setLanguage, getLanguage } from 'react-switch-lang';

import en from './wording/language/en';
import th from './wording/language/th';

setTranslations({ en, th });

setDefaultLanguage('en');

if (getLanguage() === 'th' || getLanguage() === 'en') {
    setLanguage(getLanguage());
}

setLanguageCookie('language', { maxAge: 86400 }, undefined);

const render = (Component) => {
    ReactDom.render(
        <AppContainer>
            <Component />
        </AppContainer>,
        document.getElementById('root'),
    );
};

render(RootContainer);

if (module.hot) {
    module.hot.accept('./app/routes/Root', () => render(RootContainer));
}



// WEBPACK FOOTER //
// ./src/index.js